import AssignedComplaints from "../../../jsx/components/Dashboard/AssignedComplaints/assignedcomplaints";

const AssignedComplaintsWrapper = () => {
  return <AssignedComplaints />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.compliance_officer_general];
export default constore(AssignedComplaintsWrapper);
